import { Component, AfterViewInit, ViewChild, ElementRef, Input, OnChanges, DoCheck } from '@angular/core';
import { GridOptions } from 'ag-grid';
import * as encoding from 'encoding-japanese';
import { AgGridHelper } from '../../../util/AgGridHelper';
import { ShipService } from '../../../service/ship/ship.service';
import { OwnerService } from '../../../service/owner/owner.service';
import { CommonService } from '../../../service/common/common.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';

@Component({
  selector: 'wa3015',
  templateUrl: 'wa3015.component.html',
  styleUrls: ['wa3015.component.scss']
})
export class Wa3015Component implements AfterViewInit, OnChanges, DoCheck {
  private gridApi: any;
  public componentTitle = 'WA3015:出荷実績送信・荷主選択';
  private gridHelper: AgGridHelper;
  public gridOptions: GridOptions;
  public showGrid: boolean;
  public rowData: any[];
  @ViewChild('gridView')
  gridView: ElementRef;
  @ViewChild('ownerGridView')
  ownerGridView: ElementRef;
  public ownerId: number;
  public ownerResult: any;
  private dspnone: boolean = false;
  public working = false;
  public containerHeight = 500;
  public cardHeight = 500;
  public gridHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  public updprogramCd = 'wa3015';
  private errorInfo = '';
  private overlaydspnone: boolean = true;
  private selectownerId;
  private selectownerTx;
  private selectedCount = 0;
  @Input() overlay;
  private paginationGetRowCount = 0;
  private isShowSendLoading = false;
  private isEnableClearFilterButton = false;
  private startDate = null;
  private endDate = null;
  private startDateCls = '';
  private endDateCls = '';

  constructor(private shipService: ShipService, private ownerService: OwnerService, private commonService: CommonService) {
    this.gridHelper = new AgGridHelper();
    this.gridOptions = <GridOptions>{
      rowSelection: 'multiple',
      floatingFilter: true,
      enableRangeSelection: true,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems,
      onColumnResized: this.saveColumnWidth,
      pagination: true,
      onColumnMoved: () => {
        this.saveColumnOrder();
      },
      onGridReady: params => {
        this.gridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa3015_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }
        this.gridHelper.onGridReady();
      },
      onFilterChanged: () => {
        this.gridHelper.onGridFilterChanged();
        this.isEnableClearFilterButton = this.gridOptions.api.isAnyFilterPresent();
      },
      overlayLoadingTemplate: this.gridHelper.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.gridHelper.TEMPLATE_GRID_NODATA,
      onSortChanged: () => {
        this.gridHelper.renderGridCheckboxImage();
      },
      onRowDataChanged: () => {
        this.gridHelper.onRowDataChanged();
        if (this.gridOptions.rowData && this.gridOptions.rowData.length > 0) this.gridHelper.isShowGridNoDataOverlay = false;
        else this.gridHelper.isShowGridNoDataOverlay = true;
      },
      onSelectionChanged: () => {
        this.errorInfo = '';
      },
      onPaginationChanged: () => {
        this.paginationGetRowCount = this.gridOptions.api.paginationGetRowCount();
        this.gridHelper.renderGridCheckboxImage();
      }
    };
    this.gridOptions.columnDefs = [
      {
        headerName: '',
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        width: 30,
        checkboxSelection: true,
        suppressSorting: true,
        suppressFilter: true,
        pinned: true,
        cellClass: ['tc', 'noCellFocus']
      },
      {
        headerName: '荷主コード',
        field: 'ownerCd',
        width: this.getColumnWidth('ownerCd', 200),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '荷主名',
        field: 'ownerTx',
        width: this.getColumnWidth('ownerTx', 462),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      }
    ];

    this.gridHelper.setGridOptions(this.gridOptions);
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
    this.close();
  }

  getColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa3015_${id}_width`), 10) || def;
  }

  saveColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa3015_${params.column.colId}_width`, params.column.actualWidth);
    }
  }

  saveColumnOrder() {
    let idx = 0;
    for (const column of this.gridApi.columnApi.getAllDisplayedColumns()) {
      if (column.colId !== '0') {
        localStorage.setItem(`wa3015_${column.colId}_idx`, `${idx}`);
      }
      idx++;
    }
  }

  getContextMenuItems(params) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };

    const download = csvString => {
      // Unicode コードポイントの配列に変換する
      const unicode_array = str_to_unicode_array(csvString);
      // S-JIS コードポイントの配列に変換
      const sjis_code_array = encoding.convert(
        unicode_array, // ※文字列を直接渡すのではない点に注意
        'SJIS', // to
        'UNICODE' // from
      );
      // 文字コード配列をTypedArrayに変換する
      const uint8_array = new Uint8Array(sjis_code_array);
      // 指定されたデータを保持するBlobを作成する
      const blob = new Blob([uint8_array], { type: 'text/csv' });
      // Internet Explorer
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'export.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    };

    const result = [
      'copy',
      'copyWithHeaders',
      'separator',
      {
        name: 'エクスポート',
        subMenu: [
          {
            name: 'チェックした行をCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv({ onlySelected: true }));
            }
          },
          {
            name: 'すべてCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv());
            }
          },
          'excelExport'
        ]
      }
    ];

    return result;
  }

  ngAfterViewInit() {
    this.gridHelper.el = this.gridView;
    setTimeout(() => {
      this.onSubmit();
    }, 500);

    let Fromdate = new Date();
    let Todate = new Date();
    Fromdate.setDate(Fromdate.getDate() - 30);
    setTimeout(() => {
      this.startDate = Fromdate.getFullYear() + '-' + this.pad(Fromdate.getMonth() + 1, 2) + '-' + this.pad(Fromdate.getDate(), 2);
      this.endDate = Todate.getFullYear() + '-' + this.pad(Todate.getMonth() + 1, 2) + '-' + this.pad(Todate.getDate(), 2);
    }, 500);
  }

  pad(num, totalStringSize) {
    var asString = num + '';
    while (asString.length < totalStringSize) asString = '0' + asString;
    return asString;
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
  }

  onFilterClear() {
    this.gridOptions.api.setFilterModel(null);
  }

  onSubmit() {
    this.isShowSendLoading = true;
    this.selectedCount = 0;
    this.ownerService
      .get()
      .then(outputJson => {
        this.isShowSendLoading = false;
        this.rowData = outputJson.owners;
      })
      .catch(error => {
        this.isShowSendLoading = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  sendResult() {
    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.isShowSendLoading = true;
    let FromdateCmp = new Date(this.startDate);
    let TodateCmp = new Date(this.endDate);
    FromdateCmp.setDate(FromdateCmp.getDate() + 30)
    if(FromdateCmp < TodateCmp){
      this.errorInfo = '送信期間は最大31日間まで選択可能です。再度、選び直してください。';
      this.isShowSendLoading = false;
      this.working = false;
      return;
    }
    if (this.ownerId === undefined) {
      if (this.gridOptions.api.getSelectedNodes().length === 0) {
        this.errorInfo = '対象を選択して下さい';
        this.isShowSendLoading = false;
        this.working = false;
        return;
      }
      const selectItems: object[] = [];
      for (let i = 0; i < this.gridOptions.api.getSelectedNodes().length; i++) {
        const rowIndex: number = +this.gridOptions.api.getSelectedNodes()[i]['id'];
        const jsonUnit: object = {
          ownerId: this.rowData[rowIndex]['ownerId']
        };
        selectItems.push(jsonUnit);
      }
      this.shipService
        .sendResult(selectItems, this.updprogramCd, this.startDate, this.endDate)
        .then(outputJson => {
          setTimeout(() => {
            this.isShowSendLoading = false;
            this.working = false;
            this.onSubmit();
            this.close();
            sessionStorage.setItem('SuccessInfoMessage', '出荷実績を送信しました。');
          },300);
        })
        .catch(error => {
          console.log(this.commonService.getErrorMessage(error));
          this.errorInfo = this.commonService.getErrorMessage(error);
          this.isShowSendLoading = false;
          this.working = false;

          sessionStorage.setItem('wa3015ErrorMsg', this.errorInfo);
          this.close();
          this.ownerId = undefined;
        });
    } else {
      this.isShowSendLoading = true;
      const selectItems: object[] = [];
      const jsonUnit: object = {
        ownerId: this.selectownerId
      };
      selectItems.push(jsonUnit);
      this.isShowSendLoading = true;
      this.shipService
        .sendResult(selectItems, this.updprogramCd, this.startDate, this.endDate)
        .then(outputJson => {
          setTimeout(() => {
            this.isShowSendLoading = false;
            this.working = false;
            this.onSubmit();
            this.close();
            this.ownerId = undefined;
            sessionStorage.setItem('SuccessInfoMessage', '出荷実績を送信しました。');
          },300);
        })
        .catch(error => {
          this.isShowSendLoading = false;
          this.working = false;
          console.log(this.commonService.getErrorMessage(error));
          this.errorInfo = this.commonService.getErrorMessage(error);
          sessionStorage.setItem('wa3015ErrorMsg', this.errorInfo);
          this.close();
          this.ownerId = undefined;
        });
    }
  }

  close() {
    this.dspnone = true;
    this.overlaydspnone = true;
    this.errorInfo = '';
    this.ownerId = undefined;
  }

  ngOnChanges() {
    if (this.overlay) {
      this.ownerResult = sessionStorage.getItem('ownerResult');
      if (this.ownerResult !== null) {
        const selectedOwner = JSON.parse(this.ownerResult);
        if (selectedOwner.ownerId) {
          this.ownerId = selectedOwner.ownerId;
        } else {
          this.ownerId = undefined;
        }
      }
      if (this.ownerId === undefined) {
        this.dspnone = false;
        this.overlaydspnone = true;
      } else {
        this.selectownerId = JSON.parse(sessionStorage.getItem('ownerResult')).ownerId;
        this.selectownerTx = JSON.parse(sessionStorage.getItem('ownerResult')).ownerTx;
        this.overlaydspnone = false;
        this.dspnone = true;
      }
    }
  }

  ngDoCheck() {
    if (this.gridOptions.api) {
      this.selectedCount = this.gridOptions.api.getSelectedRows().length;
    } else {
      this.selectedCount = 0;
    }
  }

  clrErr() {
    this.errorInfo = '';
  }

  clearDate() {
    this.errorInfo = '';
    this.startDate = '';
    this.endDate = '';
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa3Shipment/wa3015/wa3015.component.ts